export class MapWithDefault extends Map {
    constructor(iterable, defaultFunc) {
        super(iterable);
        this.defaultFunc = defaultFunc;
    }
    get(key) {
        let v = super.get(key);
        if (v === undefined) {
            v = this.defaultFunc(key);
            super.set(key, v);
        }
        return v;
    }
}
//# sourceMappingURL=maps.js.map